import React, { useEffect, useState } from 'react'
import { Form, Input, Select, Checkbox, Button, InputNumber, notification, Space, Card, Row, Col} from 'antd';
import axios from 'axios';
import './AddBus.css'


// Option data for Select
const { Option } = Select;
function AddBus() {
  const [form] = Form.useForm();
  const [stations, setStations] = useState([]);
  const [selectedInBetweenMainStations, setSelectedInBetweenMainStations] = useState([]);
  const [inBetweenSubStations, setInBetweenSubStations] = useState([]);

  const backend_url = process.env.REACT_APP_BACKEND_URL



  
  useEffect(() => {
    // Fetch station data from API
    // axios.get(`http://localhost:8000/stations`)
    axios.get(`${backend_url}/stations`)
      .then(response => {
        const data = response.data;
        const stationOptions = data.map(station => ({
          mainStation: station.mainStation,
          subStations: station.subStations
        }));
        setStations(stationOptions);
      })
      .catch(error => {
        console.error('Error fetching station data:', error);
      });
  }, []);

  const handleInBetweenMainStationsChange = (values) => {
    setSelectedInBetweenMainStations(values);

    // Fetch and set sub-stations for all selected in-between main stations
    const selectedStations = stations.filter(station => values.includes(station.mainStation));
    const combinedSubStations = selectedStations.flatMap(station => station.subStations);
    setInBetweenSubStations([...new Set(combinedSubStations)]); // Ensure unique sub-stations
  };

  const onFinish = async (values) => {
    console.log(values)
    try {
      // const response = await axios.post('http://localhost:8000/api/buses', values);
      const response = await axios.post(`${backend_url}/api/buses`, values);
      console.log('Bus created successfully:', response.data);

      // Notify user
      notification.success({
        message: 'Bus Created',
        description: 'The new bus has been created successfully.',
      });

      // Reset form
      form.resetFields();
    } catch (error) {
      console.error('Error creating bus:', error);

      // Notify user
      notification.error({
        message: 'Creation Failed',
        description: 'Failed to create the bus. Please try again.',
      });
    }
  };








  return (
    <>
      <div className="admin-panel">
        <Card title="Create New Bus" bordered={false} className="card">
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            className="form"
          >
            <Row gutter={16}>
              <Col xs={24} sm={12} md={12} lg={8}>
                <Form.Item
                  label="Bus Name"
                  name="name"
                  rules={[{ required: true, message: 'Please enter the bus name!' }]}
                >
                  <Input placeholder="Enter bus name" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={12} lg={8}>
                <Form.Item
                  label="Bus Number"
                  name="number"
                  rules={[{ required: true, message: 'Please enter the bus number!' }]}
                >
                  <Input placeholder="Enter bus number" />
                </Form.Item>
              </Col>

             

              <Col xs={24} sm={12} md={12} lg={8}>
                <Form.Item
                 label="Timing"
                 name="timing"
                 rules={[{ required: true, message: 'Please enter the bus timing!' }]}
                >
                  <Input min={1} style={{ width: '100%' }}
                 placeholder='Please enter the bus timing in HH:MM - HH:MM Format!'
                 />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={12} lg={8}>
                <Form.Item
                  label="Number of Seats"
                  name="seats"
                  rules={[{ required: true, message: 'Please enter the number of seats!' }]}
                >
                  <InputNumber min={1} style={{ width: '100%' }} />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={12} lg={8}>
                <Form.Item
                 label="Fare"
                 name="fare"
                 rules={[{ required: true, message: 'Please enter the bus Fare!' }]}
                >
                  <InputNumber min={1} style={{ width: '100%' }}
                 placeholder='Please enter the Fare in Rs'
                 />
                </Form.Item>
              </Col>


            </Row>

            <Row gutter={16}>
              <Col xs={24} sm={12} md={12} lg={8}>
                <Form.Item
                  label="From Station"
                  name="fromStation"
                  rules={[{ required: true, message: 'Please select the starting station!' }]}
                >
                  <Select placeholder="Select from station">
                    {stations.map(station => (
                      <Option key={station.mainStation} value={station.mainStation}>
                        {station.mainStation}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={12} lg={8}>
                <Form.Item
                  label="To Station"
                  name="toStation"
                  rules={[{ required: true, message: 'Please select the destination station!' }]}
                >
                  <Select placeholder="Select to station">
                    {stations.map(station => (
                      <Option key={station.mainStation} value={station.mainStation}>
                        {station.mainStation}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={12} lg={8}>
                <Form.Item
                  label="In Between Main Stations"
                  name="inBetweenMainStations"
                >
                  <Select
                    mode="multiple"
                    placeholder="Select in-between main stations"
                    onChange={handleInBetweenMainStationsChange}
                  >
                    {stations.map(station => (
                      <Option key={station.mainStation} value={station.mainStation}>
                        {station.mainStation}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={12} lg={8}>
                <Form.Item
                  label="In Between Stations"
                  name="inBetweenStations"
                >
                  <Select mode="multiple" placeholder="Select in-between stations">
                    {inBetweenSubStations.map((subStation, index) => (
                      <Option key={index} value={subStation}>
                        {subStation}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              name="features"
              label="Bus Features"
            >
            
              <Checkbox.Group>
                <Space direction="horizontal" wrap className="features-checkbox-group">
                  <Checkbox value="ac">AC</Checkbox>
                  <Checkbox value="nonAc">Non-AC</Checkbox>
                  <Checkbox value="charger">Charger</Checkbox>
                  <Checkbox value="foods">Foods</Checkbox>
                  <Checkbox value="water_bottle">Water Bottle</Checkbox>
                  <Checkbox value="blanket">Blanket</Checkbox>
                  <Checkbox value="track">Track</Checkbox>
                  <Checkbox value="toilet">Toilet</Checkbox>
                  <Checkbox value="bed_sheet">Bed Sheet</Checkbox>
                </Space>
              </Checkbox.Group>
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" className="submit-button">
                Create Bus
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </>
  )
}

export default AddBus